<template>
  <a-card>
    <span slot="title"
      ><a-tag color="green">{{ mode == "Create" ? "Create" : "Edit" }}</a-tag>
      Financing</span
    >
    <div slot="extra">
      Revision no :
      {{
        dataProcessed.information.revisi_no
          ? dataProcessed.information.revisi_no
          : 0
      }}
    </div>

    <a-steps :current="current" status="process">
      <a-step title="Information" />
      <a-step v-if="stepRuleDtl" title="Payment Details" />
      <a-step title="Approval" />
    </a-steps>
    <div
      class="steps-content flex-1"
      :class="
        steps[current].content == 'Detail' ? 'padding-remove border-none' : ''
      "
    >
      <component
        class="flex-1"
        :is="steps[current].content"
        :ref="stepRef"
        v-bind="stepProps"
      ></component>
    </div>
    <template class="ant-card-actions" slot="actions">
      <div class="steps-action">
        <a-button v-if="current < steps.length - 1" type="primary" @click="next"
          >Next</a-button
        >
        <a-button
          v-if="current == steps.length - 1"
          type="primary"
          :loading="loading.submit"
          @click="validate"
          >Save</a-button
        >
        <a-button v-if="current > 0" @click="prev">Previous</a-button>
      </div>
    </template>
  </a-card>
</template>

<script>
import { mapGetters } from "vuex";
import Information from "./steps/Information.vue";
import Detail from "./steps/FinancingDetail.vue";
import Approval from "./steps/Approval.vue";
import moment from "moment";
import nanoid from "nanoid";
export default {
  name: "create-financing",
  props: ["id", "type"],
  components: {
    Information,
    Detail,
    Approval,
  },
  data() {
    return {
      current: 0,
      mode: "Create",
      loading: {
        submit: false,
      },
      dataProcessed: {
        information: {},
      },
      steps: [
        {
          title: "Information",
          content: "Information",
        },
        {
          title: "Detail",
          content: "Detail",
        },
        {
          title: "Approval",
          content: "Approval",
        },
      ],
      stepRuleDtl: false,
    };
  },
  computed: {
    ...mapGetters([
      "getAuth",
      "getApproval",
      "getFinanceDetail",
      "getFinanceHutang",
      "getInformationFinancing",
      "getDateTimeStandartFormat",
      "getStandartFormatDate",
    ]),
    tipe(){
      let output;
      if (this.type == 'revisi'){
        output = 'edit'
      }else if(this.type == 'revisiwf'){
        output = 'revisi'
      }else if (this.type == 'amandemen'){
        output = 'amandemen'
      }

      return output
    }, 
    stepProps: function () {
      let result = null;
      if (this.steps[this.current].content === "Information") {
        result = {
          dataProcessed: this.dataProcessed,
          mode: this.mode,
          type: this.type
        };
      } else if (this.steps[this.current].content === "Detail") {
        result = {
          dataProcessed: this.dataProcessed,
          mode: this.mode,
          type: this.type
        };
      } else if (this.steps[this.current].content === "Approval") {
        result = {
          dataProcessed: this.dataProcessed,
          mode: this.mode,
          type: this.type
        };
      }
      return result;
    },
    stepRef: function () {
      let result = null;
      if (this.steps[this.current].content === "Information") {
        result = "refInformation";
      } else if (this.steps[this.current].content === "Detail") {
        result = "refDetail";
      } else if (this.steps[this.current].content === "Approval") {
        result = "refApproval";
      }
      return result;
    },
  },
  created() {
    this.$store.commit("setInitialFinance");
    if (this.id) {
      this.mode = "Edit";
      this.$store.commit("setPageMode", "Edit");
    } else {
      this.mode = "Create";
      this.$store.commit("setPageMode", "Create");
    }
  },
  methods: {
    moment,
    fetchApproval() {
      this.$store.dispatch("getApproval", { auth: this.getAuth });
    },
    fetch() {
      if (this.mode === "Edit") {
        this.$store
          .dispatch("getFinanceEdit", {
            auth: this.getAuth,
            params: {
              id: this.id,
              type: this.tipe,
            },
          })
          .then((response) => {
            const information = {
              id_financing: response.data.header[0].id_financing,
              offering_letter_date:
                response.data.header[0].offering_letter_date,
              offering_letter_number:
                response.data.header[0].offering_letter_number,
              type_financing: response.data.header[0].type_financing,
              debitur: response.data.header[0].debitur,
              bentuk_kredit: response.data.header[0].bentuk_kredit,
              keperluan: response.data.header[0].keperluan,
              suku_bunga: response.data.header[0].suku_bunga,
              time_period: [
                response.data.header[0].jkw_start_dt,
                response.data.header[0].jkw_end_dt,
              ],
              jml_fasilitas: response.data.header[0].jml_fasilitas,
              angunan: response.data.header[0].angunan,
              denda_penalty: response.data.header[0].denda_penalty,
              provisi: response.data.header[0].provisi,
              biaya_admin: response.data.header[0].biaya_admin,
              doc_existing: response.data.header[0].file_doc_support,
              url: response.data.header[0].url,
              revisi_no: response.data.header[0].revisi_no,
              total_penarikan: response.data.header[0].total_penarikan
            };

            const financeDetail = response.data.detil;

            if (response.data.detil.length > 0) {
              response.data.detil.forEach((data) => {
                this.$store.commit("setFinanceHutang", data);
              });
            }

            this.dataProcessed.catatan = response.data.header[0].catatan;
            this.dataProcessed.information = information;
            this.dataProcessed.detail = financeDetail;
            this.dataProcessed.approval = {
              tlc: response.data.header[0].tlc_approval,
              nama: response.data.header[0].nama_approval,
            };

            this.$store.commit("setInformationFinancing", information);
            this.$store.commit("setFinanceDetail", financeDetail);
            Event.$emit(
              "setstepRulesDtl",
              response.data.header[0].type_financing == "FP" ? true : false
            );
          });
      }
    },
    next() {
      if (this.steps[this.current].content === "Information") {
        this.$refs.refInformation.handleRef();
      } else if (this.steps[this.current].content === "Detail") {
        this.$refs.refDetail.handleRef();
      } else if (this.steps[this.current].content === "Approval") {
        this.$refs.refApproval.handleRef();
      }
    },
    prev() {
      if (this.steps[this.current].content === "Approval") {
        if (!this.stepRuleDtl) {
          this.current = this.current - 2;
        } else {
          this.current--;
        }
      } else {
        this.current--;
      }
    },
    validate() {
      this.$refs.refApproval.handleRef();
    },
    valueFromChild(value) {
      if (this.steps[this.current].content === "Information") {
        value.angunan = value.angunan ? value.angunan : "";
        value.denda_penalty = value.denda_penalty ? value.denda_penalty : "";
        value.biaya_admin = value.biaya_admin ? value.biaya_admin : 0;
        value.provisi = value.provisi ? value.provisi : 0;
        this.dataProcessed.information = value;
        this.$store.commit("setInformationFinancing", value);
        if (this.stepRuleDtl) {
          this.current++;
        } else {
          this.current = this.current + 2;
        }
      } else if (this.steps[this.current].content === "Detail") {
        this.dataProcessed.detail = value;
        this.current++;
      } else {
        this.dataProcessed.catatan = value;
        this.submit();
      }
    },
    submit() {
      this.loading.submit = true;
      let postData = new FormData();
      postData.append("tlc", this.getAuth.username);

      // Information
      postData.append(
        "offering_letter_date",
        moment(this.getInformationFinancing.offering_letter_date).format(
          this.getDateTimeFormat
        )
      );
      postData.append(
        "offering_letter_number",
        this.getInformationFinancing.offering_letter_number
      );
      postData.append("debitur", this.getInformationFinancing.debitur);
      postData.append(
        "bentuk_kredit",
        this.getInformationFinancing.bentuk_kredit
      );
      postData.append(
        "denda_penalty",
        this.getInformationFinancing.denda_penalty
      );
      postData.append("angunan", this.getInformationFinancing.angunan);
      postData.append("suku_bunga", this.getInformationFinancing.suku_bunga);
      postData.append("keperluan", this.getInformationFinancing.keperluan);
      postData.append(
        "jkw_start_dt",
        this.dataProcessed.information.jkw_start_dt
      );
      postData.append("jkw_end_dt", this.dataProcessed.information.jkw_end_dt);
      postData.append(
        "jml_fasilitas",
        this.dataProcessed.information.jml_fasilitas
      );
      postData.append("provisi", this.dataProcessed.information.provisi);
      postData.append(
        "biaya_admin",
        this.dataProcessed.information.biaya_admin
      );
      postData.append(
        "type_financing",
        this.dataProcessed.information.type_financing
      );

      if (this.mode == "Edit") {
        postData.append("id_financing", this.id);
      }

      // Approval
      postData.append("catatan", this.dataProcessed.catatan ? this.dataProcessed.catatan : "");
      postData.append(
        "tlc_approval",
        this.mode == "Create"
          ? this.getApproval.tlc_direktur
          : this.dataProcessed.approval.tlc
      );

      // Detail
      if (this.mode == "Edit") {
        if (!this.getInformationFinancing.doc_financing) {
          postData.append(
            "file_doc_support",
            this.getInformationFinancing.doc_existing
          );
        } else {
          postData.append(
            "doc_financing",
            this.getInformationFinancing.doc_financing
          );
        }
      } else {
        postData.append(
          "doc_financing",
          this.getInformationFinancing.doc_financing
        );
      }

      this.getFinanceHutang.forEach((data, index) => {
        if (this.mode == "Edit") {
          postData.append(
            `id_financing_dtl[${index}]`,
            data.id_financing_dtl ? data.id_financing_dtl : nanoid()
          );
        }
        postData.append(`total[${index}]`, data.total);
        postData.append(`pokok[${index}]`, data.pokok);
        postData.append(`bunga[${index}]`, data.bunga);
        postData.append(`tahun[${index}]`, data.tahun);
        postData.append(`bulan[${index}]`, data.bulan);
      });

      postData.append("tipe", this.tipe)

      this.$store
        .dispatch("submitFinancing", {
          auth: this.getAuth,
          payload: postData,
        })
        .then((res) => {
          this.loading.submit = false;
          //this.$store.commit("setInitialFinance");
          this.$router.push({
            name: "financing-list",
          });
          this.displayMessageValue("success-other", res.message);
        })
        .catch((err) => {
          console.log("error : " + err);
        });
    },
    setstepRulesDtl(value) {
      this.stepRuleDtl = value;
    },
  },
  mounted() {
    this.fetchApproval();
    this.fetch();
    Event.$on("dataProcessed", this.valueFromChild);
    Event.$on("setstepRulesDtl", this.setstepRulesDtl);
  },
  beforeDestroy() {
    Event.$off("dataProcessed", this.valueFromChild);
    Event.$off("setstepRulesDtl", this.setstepRulesDtl);
  },
};
</script>

<style lang="less">
.border-none {
  border: none;
}
</style>
